// extracted by mini-css-extract-plugin
export default {"defaultTr":"TableItem_defaultTr__YDdyW","extendTrContainerDiv":"TableItem_extendTrContainerDiv__j-Tsh"};